const images = {
  logo: require("./images/logo_512.png"),
  logo_letters: require("./images/logo_512.png"),
  introWallpaper: require("./images/logistics_wallpaper.jpg"),
  barWallpaper: require("./images/bar_panoramic.jpg"),
  bar: require("./images/bar_wallpaper.jpg"),
};
export default images;
